import {
    req,
    Request
  } from '../Repository';
  import {
    setFullToken,
    checkTokenHeaders
  } from '../apiHelper'
  
  const resource = '/xdent/credit';

  export default {
    getAllCredits: token => {
        return req(token).then(token => {
            return Request.get(`${resource}/getclientcredithistory`, token);
        }) 
    }
  }